var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 22,
    viewBox: "0 0 53 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7962 14.3262C40.3766 14.3262 36.7617 17.741 36.5924 22H53C52.8302 17.741 49.2154 14.3262 44.7962 14.3262Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7962 13.7005C46.7016 13.7005 48.252 12.1923 48.252 10.3383C48.252 8.48426 46.7016 6.97561 44.7962 6.97561C42.8904 6.97561 41.34 8.48385 41.34 10.3383C41.34 12.1923 42.8904 13.7005 44.7962 13.7005Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74761 10.3387C4.74761 12.1923 6.29799 13.7009 8.20381 13.7009C10.1092 13.7009 11.6596 12.1927 11.6596 10.3387C11.6596 8.48468 10.1092 6.97603 8.20381 6.97603C6.29799 6.97603 4.74761 8.48426 4.74761 10.3387Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20381 14.3262C3.7842 14.3262 0.169358 17.741 0 22H16.4076C16.2378 17.741 12.623 14.3262 8.20381 14.3262Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0842 11.1679L36.1267 14.1558C36.3134 14.3392 36.3134 14.6364 36.1267 14.8198L33.0842 17.8078C32.8975 17.9911 32.5947 17.9911 32.408 17.8078C32.2213 17.6244 32.2213 17.3271 32.408 17.1438L34.6344 14.9573H16.6649C16.4009 14.9573 16.1869 14.7471 16.1869 14.4878C16.1869 14.2285 16.4009 14.0183 16.6649 14.0183H34.6344L32.408 11.8318C32.2213 11.6485 32.2213 11.3512 32.408 11.1679C32.5947 10.9845 32.8975 10.9845 33.0842 11.1679Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6611 0.804878H23.4265C22.3704 0.804878 21.5142 1.64571 21.5142 2.68293V6.84146C21.5142 7.87868 22.3704 8.71951 23.4265 8.71951H29.0271C29.3288 8.71951 29.5735 8.47927 29.5735 8.18293V2.68293C29.5735 1.64571 28.7173 0.804878 27.6611 0.804878ZM23.4265 0C21.9177 0 20.6946 1.20119 20.6946 2.68293V6.84146C20.6946 8.3232 21.9177 9.52439 23.4265 9.52439H29.0271C29.7815 9.52439 30.393 8.9238 30.393 8.18293V2.68293C30.393 1.20119 29.1699 0 27.6611 0H23.4265Z",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5438 6.97561C26.7509 6.97561 27.7294 6.01466 27.7294 4.82927C27.7294 3.64388 26.7509 2.68293 25.5438 2.68293C24.3368 2.68293 23.3582 3.64388 23.3582 4.82927C23.3582 6.01466 24.3368 6.97561 25.5438 6.97561ZM25.5438 6.30488C26.3737 6.30488 27.0464 5.64423 27.0464 4.82927C27.0464 4.01431 26.3737 3.35366 25.5438 3.35366C24.714 3.35366 24.0412 4.01431 24.0412 4.82927C24.0412 5.64423 24.714 6.30488 25.5438 6.30488Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.4722410da3f8399e2613c2904c1b38c3.svg";
export { ForwardRef as ReactComponent };